import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectPurchaseInvoicePdfUrlsEntry } from '../selectors/invoices.selectors';
import { getPurchaseInvoicePdfUrls } from '../services/getPurchaseInvoicePdfUrls.service';

// The links are signed for 15 minutes; reuse them for 10.
export const PDF_URLS_MAX_AGE_MS = 10 * 60 * 1000;

const toProjectIds = (projectIds) => [
  ...new Set((projectIds || []).filter(Boolean)),
];

// `projectIds` are tried in order until one lists the invoice: Filings can
// open an invoice listed under another project than its own.
export const loadPurchaseInvoicePdfUrls = createAsyncThunk(
  'invoices/loadPurchaseInvoicePdfUrls',
  async ({ invoiceId, projectIds }) => {
    let lastError;
    for (const projectId of toProjectIds(projectIds)) {
      try {
        const urls = await getPurchaseInvoicePdfUrls(projectId, invoiceId);
        return { urls: Array.isArray(urls) ? urls : [], fetchedAt: Date.now() };
      } catch (error) {
        lastError = error;
      }
    }
    throw lastError;
  },
  {
    condition: ({ invoiceId, projectIds }, { getState }) => {
      if (!invoiceId || toProjectIds(projectIds).length === 0) {
        return false;
      }
      const entry = selectPurchaseInvoicePdfUrlsEntry(getState(), invoiceId);
      if (entry?.loading) {
        return false;
      }
      return (
        !entry?.fetchedAt || Date.now() - entry.fetchedAt > PDF_URLS_MAX_AGE_MS
      );
    },
  }
);
